// extracted by mini-css-extract-plugin
module.exports = {"linkGroup":"link-group-module--link-group--2e02Q"};